exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section#intro-banner{background:url(/images/banner-gray.jpg) no-repeat bottom/cover;padding:0}.act-car-img{top:-80px!important}.new-car,.old-car{border-radius:20px!important}.new-car.act-car:hover{background:#222}.old-car.act-car:hover{background:#fa2837}.act-car{padding:20px 50px!important}.icon-wrap{background:#eaeaea;width:120px;height:120px;border-radius:50%;text-align:center;line-height:110px;margin:0 auto 20px}", ""]);

// exports
